export default __webpack_public_path__ + "static/media/GANESHA INDISCHES RESTAURANT FULL MENU.daa11f76.pdf";